import { useState } from 'react';
import { Slider } from '../controls/Slider';
import { useActive } from './useActive';
import { useT, type MessageKey } from '../../i18n';
import { HUE_BANDS, type HueBand } from '../../color/hsl';

type Channel = 'h' | 's' | 'l';
const TABS: { key: Channel; label: MessageKey }[] = [
  { key: 'h', label: 'hslHue' },
  { key: 's', label: 'hslSat' },
  { key: 'l', label: 'hslLum' },
];
const BAND_LABEL: Record<HueBand, MessageKey> = {
  red: 'bandRed',
  orange: 'bandOrange',
  yellow: 'bandYellow',
  green: 'bandGreen',
  aqua: 'bandAqua',
  blue: 'bandBlue',
  purple: 'bandPurple',
  magenta: 'bandMagenta',
};

/** §6.5 HSL: Hue / Saturation / Luminance tabs, one slider per OkLCh hue band. */
export function HslPanel() {
  const t = useT();
  const { settings, update } = useActive();
  const [tab, setTab] = useState<Channel>('h');
  return (
    <div>
      <div role="tablist" style={{ display: 'flex', gap: 4, marginBottom: 6 }}>
        {TABS.map(({ key, label }) => (
          <button
            key={key}
            role="tab"
            aria-selected={tab === key}
            data-testid={`hsl-tab-${key}`}
            onClick={() => setTab(key)}
            style={tab === key ? { background: 'var(--accent)', color: '#fff' } : undefined}
          >
            {t(label)}
          </button>
        ))}
      </div>
      {HUE_BANDS.map((band) => (
        <Slider
          key={`${tab}-${band}`}
          label={BAND_LABEL[band]}
          testId={`slider-hsl-${band}-${tab}`}
          value={settings.hsl[band][tab]}
          min={-100}
          max={100}
          step={1}
          onChange={(v, f) => update((s) => void (s.hsl[band][tab] = v), f)}
        />
      ))}
    </div>
  );
}
